import SVG from './NotFound.svg';

const Animation = ({ className }: { className?: string }) => (
  <object type="image/svg+xml" data={SVG} className={className}>
    Not Found Animation
  </object>
);

export default Animation;
